import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import { accessLocalStorage, valuesAnalyze, changeViewForms, exportSelectAllQueues, exportSelectAllTrunks, exportSelectAllEndpoints, applyDialplanSystem, entranceDialplan } from '../../../services';
import FormEntranceCalls from './components/formIpSetDialPlanEntrance';

import '../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function DilaplanEntranceCalls() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElementsActive, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [values, setValues] = useState({
    entrance: {
      trunk: "",
      mask: "",
      firstTime: 0,
      only: false,
      overflow: "",
      redirect: {
        type: "",
        destination: "",
        overflowData: {
          typeOverFlow: "",
          destinationOverflow: ""
        }
      }
    }
  });
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [trunks, setTrunks] = useState([]);
  const [queues, setQueues] = useState([]);
  const [endpoints, setEndpoints] = useState([]);
  const [toggleRedirect, setToggleRedirect] = useState('vazio');
  const [toggleOverflowRedirect, setToggleOverflowRedirect] = useState('');
  const [messageResultReturn, setMessageResultReturn] = useState('');
  const [resultMessage, setResultMessage] = useState({});
  const [inputDisable, setinputDisable] = useState(false);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    const trunksList = await exportSelectAllTrunks();
    if(trunksList === undefined) setLoading(true);
    const fetchedTrunks = trunksList.map((element) => element.trunksselect);
    setTrunks(fetchedTrunks);

    const queuesList = await exportSelectAllQueues();
    if(queuesList === undefined) setLoading(true);
    const fetchedQueues = queuesList.map((element) => element.queuesselect);
    setQueues(fetchedQueues);

    const endpointsList = await exportSelectAllEndpoints();
    if(endpointsList === undefined) setLoading(true);
    const fetchedEndpoints = endpointsList.map((element) => element.endpoint).filter((element) => !isNaN(Number(element)));
    setEndpoints(fetchedEndpoints);
    
    return;
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(!check, `${name}-placeholder-data`);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isQuadChar } = valuesAnalyze;

    let checkValueIsCharacters = false;

    const redirectType = values.entrance.redirect.type;
    const redirectOverflowType = values.entrance.redirect.overflowData.typeOverFlow;
    const redirectDst = values.entrance.redirect.destination;
    const redirectOverflowDst = values.entrance.redirect.overflowData.destinationOverflow;

    if (name === 'trunk' || name === 'mask') checkValueIsCharacters = Number(value.length) >= 4 && isQuadChar(value) ? true : false;
    if (name === 'only') checkValueIsCharacters = value === 'true' || value === 'false' ? true : false;
    if (name === 'overflow') checkValueIsCharacters = value === 'yes' || value === 'no' ? true : false;
    if (name === 'firstTime') checkValueIsCharacters = Number(value) >= 5 && valuesAnalyze.checkNumber(Number(value)) ? true : false;
    if (name === 'redirect-type') checkValueIsCharacters = isNaN(value) ? true : false;
    if (name === 'redirect-destination' && redirectType === 'endpoint') checkValueIsCharacters = checkNumber(Number(value)) ? true : false;
    if (name === 'redirect-destination' && redirectType === 'queue') checkValueIsCharacters = isNaN(Number(value)) ? true : false;
    if (name === 'redirect-overflowData-typeOverFlow') checkValueIsCharacters = isNaN(value) ? true : false;
    if (name === 'redirect-overflowData-destinationOverflow' && redirectOverflowType === 'endpoint') checkValueIsCharacters = !isNaN(Number(value)) ? true : false; // checkNumber(Number(value)) && Number(redirectDst) === Number(redirectOverflowDst) ? true : false;
    if (name === 'redirect-overflowData-destinationOverflow' && redirectOverflowType === 'queue' && redirectDst !== redirectOverflowDst) checkValueIsCharacters = isNaN(Number(value)) ? true : false;

    changeScreen(checkValueIsCharacters, name);
    return checkValueIsCharacters;
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    // setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);

    setValidate((prevState) => {
      let nameTmp = values.entrance.overflow;
      
      const vld = validate[name] = itemStatus === undefined  ? true : itemStatus
      if (name === 'overflow') nameTmp = value;
      if (Object.keys(prevState).length === 7 && nameTmp === 'no' && !Object.values(prevState).includes(false)) setDisable(false);
      if (Object.keys(prevState).length < 9 && nameTmp === 'yes' && !Object.values(prevState).includes(false)) setDisable(true);
      if (Object.keys(prevState).length === 9 && !Object.values(prevState).includes(false) && nameTmp === 'yes') setDisable(false);

      return { ...prevState, ...vld }
    });

    let nameList = []
    let valueBoolean;
    name.includes('-') ? nameList = name.split('-') : setValues((prevState) => prevState, values['entrance'][name] = value);
    if (name === 'only') setValues((prevState) => prevState, values['entrance'][name] = value === 'true');
    if (nameList !== [] && nameList.length === 2) setValues((prevState) => prevState, values['entrance']['redirect'][nameList[1]] = value);
    if (nameList !== [] && nameList.length === 3) setValues((prevState) => prevState, values['entrance']['redirect']['overflowData'][nameList[2]] = value);

    if (name === 'redirect-type') {
      setToggleRedirect(value)
      if (toggleRedirect !== '') toggleIsHidden(`#${toggleRedirect}`);
      if (value !== '') toggleIsHidden(`#${value}`);
    }

    if (name === 'redirect-overflowData-typeOverFlow') {
      setToggleOverflowRedirect('overflow-' + value)
      if (toggleOverflowRedirect !== '') toggleIsHidden(`#${toggleOverflowRedirect}`);
      if ('overflow-' + value !== '') toggleIsHidden(`#overflow-${value}`);
    }

    if (name === 'overflow' && value === 'yes' && values.entrance.overflow === 'yes') toggleIsChangeFormElements('columns-overflow', 'columns mx-2 is-mobile is-active');
    if (name === 'overflow' && value === 'no' && values.entrance.overflow === 'no') toggleIsChangeFormElements('columns-overflow', 'columns mx-2 is-mobile is-hidden');

    return;
  };

  const sendDataDialplanEntrance = async () => {
    const sendEntranceDilaplan = await entranceDialplan(values);
    const result = Object.keys(sendEntranceDilaplan).length > 0 ? true : false;

    if(result) {
      setMessageResultReturn();
      toggleIsHidden('#button-send-form');
      toggleIsHidden('#alert-create-call-entrance');
      toggleIsHidden('#button-send-apply');
    };
    return;
  };

  const sendApplyConfig = async () => {
    const apply = await applyDialplanSystem();
    setResultMessage(apply);
    
    toggleIsHidden('#alert-create-call-entrance');
    toggleIsHidden('#alert-return-call-entrance');
    toggleIsHidden('#button-send-apply');
    toggleIsHidden('#form-entrace');

    setTimeout(() => {
      return window.location.reload(true)
    }, 3000);
  };


  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div>
      <div className="columns has-text-centered">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <strong className="is-size-3">CHAMADAS DE ENTRADA</strong>
          <hr className="dropdown-divider"/>
        </div>
      </div>
      <article id="alert-create-call-entrance" name="alert-create-call-entrance" className="column is-half is-offset-one-quarter message is-info is-hidden">
        <div className="message-header">
          <p>Atenção!</p>
          <button className="delete" aria-label="delete" onClick={ () => {
            toggleIsHidden('#alert-create-call-entrance');
            toggleIsHidden('#button-send-form');
            toggleIsHidden('#button-send-apply');
          }}></button>
        </div>
        <div className="message-body">
          Para as configurações serem aplicadas será necessário clicar no botão <strong>Aplicar</strong> abaixo.
          <br />
        </div>
      </article>
      <article id="alert-return-call-entrance" name="alert-create-call-entrance" className="column is-half is-offset-one-quarter message is-link is-hidden">
        <div className="message-header">
          <p>Atenção!</p>
          <button className="delete" aria-label="delete" onClick={ () => {
            toggleIsHidden('#alert-return-call-entrance');
            toggleIsHidden('#button-send-apply');
          }}></button>
        </div>
        <div className="message-body">
          { resultMessage.message }
          <br />
        </div>
      </article>
      <div id="form-entrace" className="column is-full has-text-centered">
        <FormEntranceCalls handleChangeValues={ handleChangeValues } trunks={ trunks } queues={ queues } endpoints={ endpoints } toggleInput={ toggleIsChangeFormElementsActive } />
      </div>
      <div  className="columns mx-2">
        <div id="button-send-form" className="column mt-3 is-half is-4 is-offset-4 has-text-centered is-active">
          <div className="control">
            <button className="button is-info is-fullwidth" type="submit" onClick={ () => sendDataDialplanEntrance() } disabled={ disable }>
              <span>
                Criar Direcionamentos
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="columns mx-2">
        <div id="button-send-apply" className="column mt-3 is-half is-4 is-offset-4 has-text-centered is-hidden">
          <div className="control">
            <button className="button is-warning is-fullwidth" type="submit" onClick={ () => sendApplyConfig() }>
              <span>
                <strong>Aplicar</strong>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DilaplanEntranceCalls;
